<script>
import AssetableTable from '@wielink-application/asset/vue/assets/AssetableTable.vue'
export default AssetableTable;
</script>